import { CheckCheck } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface BubbleReceipt {
  delivered: number
  pending: number
  failed: number
}

interface MessageBubbleProps {
  me: boolean
  author?: string
  body: string
  receipt?: BubbleReceipt
}

// Shared chat bubble for broadcast threads and group chats. `receipt` renders
// the ✓✓ delivery line under an outbound broadcast message.
export function MessageBubble({ me, author, body, receipt }: MessageBubbleProps) {
  return (
    <div className={cn('flex max-w-[78%] flex-col', me ? 'self-end' : 'self-start')}>
      {!me && author && (
        <div className="mb-1 ml-[3px] text-[11px] font-bold text-muted-foreground">{author}</div>
      )}
      <div
        style={{
          borderRadius: 15,
          ...(me ? { borderTopRightRadius: 4 } : { borderTopLeftRadius: 4 }),
        }}
        className={cn(
          'px-3.5 py-[11px] text-[14px] leading-[1.5] [word-break:break-word] whitespace-pre-wrap',
          me
            ? 'bg-primary text-on-primary'
            : 'border border-bubble-in-border bg-bubble-in text-foreground',
        )}
      >
        {body}
      </div>
      {me && receipt && (
        <div className="mt-[5px] text-right text-[11px] font-bold text-sage-ink">
          {receipt.delivered > 0 && (
            <CheckCheck className="mr-1 inline h-3.5 w-3.5 align-[-2px]" />
          )}
          {receipt.delivered} delivered
          {receipt.pending > 0 && (
            <span className="text-muted-foreground"> · {receipt.pending} pending</span>
          )}
          {receipt.failed > 0 && (
            <span className="text-danger-ink"> · {receipt.failed} failed</span>
          )}
        </div>
      )}
    </div>
  )
}
